import { Eyebrow } from "./Eyebrow";

interface SectionHeadProps {
  eyebrow: string;
  title: React.ReactNode;
  lede?: React.ReactNode;
  align?: "center" | "left";
}

export function SectionHead({ eyebrow, title, lede, align = "center" }: SectionHeadProps) {
  return (
    <header className={`section-head${align === "left" ? " section-head--left" : ""}`}>
      <Eyebrow>{eyebrow}</Eyebrow>
      <h2>{title}</h2>
      {lede ? <p className="lede">{lede}</p> : null}
    </header>
  );
}
